// extracted by mini-css-extract-plugin
var _1 = "active-media-preview";
var _2 = "base-link";
var _3 = "btnGroup";
var _4 = "btnGroupBlock";
var _5 = "btnGroupBorderless";
var _6 = "btnGroupIsHorizontal";
var _7 = "btnGroupWithOutline";
var _8 = "#000000";
var _9 = "#76F366";
var _a = "#EB8632";
var _b = "#ECC834";
var _c = "#21FC87";
var _d = "#EA4A30";
var _e = "#C7EA45";
var _f = "#272B2B";
var _10 = "#BDBDBD";
var _11 = "#7D7D7D";
var _12 = "#6A0DAD";
var _13 = "#3A65FF";
var _14 = "#4A90E2";
var _15 = "#ffffff";
var _16 = "reset-button";
var _17 = "1200px";
var _18 = "992px";
var _19 = "1366px";
var _1a = "768px";
var _1b = "1475px";
var _1c = "576px";
var _1d = "1600px";
var _1e = "320px";
var _1f = "2500px";
var _20 = "single-page-responsive-font-size";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "btnGroup", _4 as "btnGroupBlock", _5 as "btnGroupBorderless", _6 as "btnGroupIsHorizontal", _7 as "btnGroupWithOutline", _8 as "colorBlack", _9 as "colorGradeEX", _a as "colorGradeFR", _b as "colorGradeGD", _c as "colorGradeOU", _d as "colorGradePR", _e as "colorGradeVG", _f as "colorNeutral", _10 as "colorNeutralLighest", _11 as "colorNeutralLight", _12 as "colorNonOwnerSweetLine", _13 as "colorOwnerSweetLine", _14 as "colorRegularLinks", _15 as "colorWhite", _16 as "reset-button", _17 as "screenlg", _18 as "screenmd", _19 as "screenml", _1a as "screensm", _1b as "screenxlg", _1c as "screenxs", _1d as "screenxxlg", _1e as "screenxxs", _1f as "screenxxxlg", _20 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "btnGroup": _3, "btnGroupBlock": _4, "btnGroupBorderless": _5, "btnGroupIsHorizontal": _6, "btnGroupWithOutline": _7, "colorBlack": _8, "colorGradeEX": _9, "colorGradeFR": _a, "colorGradeGD": _b, "colorGradeOU": _c, "colorGradePR": _d, "colorGradeVG": _e, "colorNeutral": _f, "colorNeutralLighest": _10, "colorNeutralLight": _11, "colorNonOwnerSweetLine": _12, "colorOwnerSweetLine": _13, "colorRegularLinks": _14, "colorWhite": _15, "reset-button": _16, "screenlg": _17, "screenmd": _18, "screenml": _19, "screensm": _1a, "screenxlg": _1b, "screenxs": _1c, "screenxxlg": _1d, "screenxxs": _1e, "screenxxxlg": _1f, "single-page-responsive-font-size": _20 }
